import { ShieldCheck, Clock, Thermometer, Wrench } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "GAF Master Elite® Certified",
    description: "Only the top 2% of roofers in North America earn this distinction. It means better materials, better warranties, and better workmanship.",
  },
  {
    icon: Clock,
    title: "Lifetime Warranty Coverage",
    description: "Our GAF certification unlocks the industry's best warranty — covering materials AND workmanship for the lifetime of your roof.",
  },
  {
    icon: Thermometer,
    title: "Energy-Efficient Systems",
    description: "We install cool-roof technology that reflects heat, lowering your energy bills and keeping your home comfortable year-round.",
  },
  {
    icon: Wrench,
    title: "We Fix Others' Mistakes",
    description: "Hired a cheap roofer and got burned? We specialize in correcting botched installations and storm damage repairs.",
  },
];

export const AdsDifferenceSection = () => (
  <section className="py-16 bg-background">
    <div className="container mx-auto px-4 max-w-5xl">
      <h2 className="text-2xl md:text-3xl font-extrabold text-foreground text-center mb-10">
        The <span className="text-primary">Safeway</span> Difference
      </h2>
      <div className="grid md:grid-cols-2 gap-6">
        {features.map(({ icon: Icon, title, description }) => (
          <div key={title} className="flex gap-4 p-5 rounded-xl border bg-card shadow-sm">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h3 className="font-bold text-foreground mb-1">{title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
